export const SET_STUDENTS = 'SET_STUDENTS';
export const SET_LOADING = 'SET_LOADING';
export const SET_MODAL = 'SET_MODAL';
export const SELECT_STUDENT = 'SELECT_STUDENT';
export const AUTH = 'AUTH';
